import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { reduxForm } from 'redux-form/immutable'

import { PROFILE_FORM_NAME as FORM_NAME } from 'app/constants/profile'
import { syncValidate as validate } from 'app/validators/profile'
import { saveProfile } from 'store/entities/identity/actions'
import { getIdentityStage, getIdentityPendingGetProfile, getIdentityUserData } from 'store/entities/identity/selectors'
import { getUIWindowSizesWidth } from 'store/entities/ui/selectors'
import Profile from './Profile'

const mapStateToProps = state => ({
  initialValues: getIdentityUserData(state),
  stage: getIdentityStage(state),
  pending: getIdentityPendingGetProfile(state),
  isMobile: getUIWindowSizesWidth(state) < 490,
})

const mapDispatchToProps = {
  onSubmit: saveProfile,
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(
    reduxForm({
      form: FORM_NAME,
      validate,
      enableReinitialize: true,
      destroyOnUnmount: false,
    })(Profile)
  )
)
